import { useQuery } from "@tanstack/react-query";

import { getStudySummary } from "@/api/stats";
import { useAuthStore } from "@/store/authStore";

/** 학습 통계 요약 (완료 테스트, 평균 점수, 학습 단어) */
export function useStudySummaryQuery() {
  const userId = useAuthStore(state => state.user?.id);

  return useQuery({
    queryKey: ["studySummary", userId],
    queryFn: () => getStudySummary(userId!),
    enabled: Boolean(userId),
  });
}
